import type { SkillTreeDef, SkillTreeDefaults } from '../types';

/**
 * Static skill tree seed data.
 * Used by the seed script to populate Firestore on first run.
 * After seeding, the app reads trees from Firestore via definitionService.
 */
export const SKILL_TREES: SkillTreeDef[] = [
  {
    id: 'water_well',
    name: 'Water Well Installation',
    shortName: 'Water Well',
    description: 'Complete training path for water well installation technicians',
    qualificationIds: ['baq', 'electrical', 'hoist', 'bighoss', 'lead_install', 'lead_diagnostic'],
    defaultDeadlines: {
      baq: 14, // 2 weeks
      electrical: 30, // 1 month
      hoist: 90, // 3 months
      bighoss: null, // optional — no default deadline
      lead_install: 270, // 9 months
      lead_diagnostic: 450, // 15 months
    },
  },
  {
    id: 'plumbing',
    name: 'Plumbing',
    shortName: 'Plumbing',
    description: 'Basic plumbing training path for testing',
    qualificationIds: ['plumb_apprentice', 'plumb_master'],
    defaultDeadlines: {
      plumb_apprentice: 30,
      plumb_master: 90,
    },
  },
];

/**
 * @deprecated Use tree.defaultDeadlines instead. Kept for backward compat with timeline utils.
 */
export const DEFAULT_DEADLINES: Record<string, SkillTreeDefaults> = Object.fromEntries(
  SKILL_TREES.map((t) => [t.id, t.defaultDeadlines])
);

/** Look up a skill tree definition by ID */
export const getSkillTree = (id: string): SkillTreeDef | undefined =>
  SKILL_TREES.find((t) => t.id === id);

/** Get default deadline (days from start) for a qual within a tree. Returns null if none. */
export const getDefaultDeadlineDays = (treeId: string, qualId: string): number | null =>
  DEFAULT_DEADLINES[treeId]?.[qualId] ?? null;
